"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'autocomplete.triggers.suggestions': 'Dostępne elementy',
    'autocomplete.triggers.noResults': 'Nie znaleziono pasujących elementów',
    'autocomplete.triggers.stylesPlaceholder': 'Wpisz / aby szukać stylów...',
    'autocomplete.triggers.projectsPlaceholder': 'Wpisz # aby szukać projektów...',
    'autocomplete.triggers.knowledgePlaceholder': 'Wpisz @ aby szukać wiedzy...',
    'autocomplete.triggers.loading': 'Ładowanie...',
    'autocomplete.triggers.error': 'Błąd ładowania sugestii',
};
